var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M5.18264 1.79167L3.90215 2.16667L1.63993 4.54167C0.402113 4.58333 1.34115 17.7083 1.34115 18.5417V35.5C1.34115 36.3333 2.32286 37 3.56068 37H33.6951C34.9329 37 36 36.3333 36 35.5V34.1667C19.3535 34.1667 6.16436 12.2083 6.16436 1L5.18264 1.79167Z",
          fill: "#E6E7E8",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.08511 40C3.61702 40 0 36.383 0 31.9149V10.6383V9.3617V8.08511C0 3.61702 3.61702 0 8.08511 0H31.9149C36.383 0 40 3.61702 40 8.08511V9.3617V10.6383V31.9149C40 36.383 36.383 40 31.9149 40H8.08511ZM37.4468 9.3617V8.08511C37.4468 5.02128 34.9787 2.55319 31.9149 2.55319H8.08511C5.02128 2.55319 2.55319 5.02128 2.55319 8.08511V9.3617H37.4468ZM2.55319 11.9149V31.9149C2.55319 34.9787 5.02128 37.4468 8.08511 37.4468H31.9149C34.9787 37.4468 37.4468 34.9787 37.4468 31.9149V11.9149H2.55319Z",
          fill: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M8.08511 40C3.61702 40 0 36.383 0 31.9149V10.6383V9.3617V8.08511C0 3.61702 3.61702 0 8.08511 0H31.9149C36.383 0 40 3.61702 40 8.08511V9.3617V10.6383V31.9149C40 36.383 36.383 40 31.9149 40H8.08511ZM37.4468 9.3617V8.08511C37.4468 5.02128 34.9787 2.55319 31.9149 2.55319H8.08511C5.02128 2.55319 2.55319 5.02128 2.55319 8.08511V9.3617H37.4468ZM2.55319 11.9149V31.9149C2.55319 34.9787 5.02128 37.4468 8.08511 37.4468H31.9149C34.9787 37.4468 37.4468 34.9787 37.4468 31.9149V11.9149H2.55319Z",
          stroke: "#FD6144",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.9149 7.65963C32.8511 7.65963 33.617 6.89367 33.617 5.9575C33.617 5.02133 32.8511 4.25537 31.9149 4.25537C30.9787 4.25537 30.2128 5.02133 30.2128 5.9575C30.2128 6.89367 30.9787 7.65963 31.9149 7.65963ZM27.7447 20.6809C27.2341 20.1703 26.4255 20.1703 25.9575 20.6809C25.4468 21.1915 25.4468 22.0001 25.9575 22.4681L28.1277 24.6383L26.0851 26.6809C25.5745 27.1915 25.5745 28.0001 26.0851 28.4681C26.5958 28.9362 27.4043 28.9788 27.8724 28.4681L30.2128 26.1277C31.0638 25.2766 31.0638 23.9575 30.2128 23.1064L27.7447 20.6809ZM14.1702 20.6809C13.6596 20.1703 12.8511 20.1703 12.383 20.6809L9.91491 23.149C9.06385 24.0001 9.06385 25.3192 9.91491 26.1703L12.2553 28.5107C12.766 29.0213 13.5745 29.0213 14.0426 28.5107C14.5107 28.0001 14.5532 27.1915 14.0426 26.7235L12 24.6809L14.1702 22.5107C14.6809 21.9575 14.6809 21.149 14.1702 20.6809ZM23.8724 19.2341C24.1702 18.5958 23.8724 17.8298 23.2341 17.532C22.5958 17.2341 21.8298 17.532 21.5319 18.1703L16.4255 29.6596C16.1277 30.2979 16.4255 31.0639 17.0638 31.3618C17.7021 31.6596 18.4681 31.3618 18.766 30.7235L23.8724 19.2341Z",
          fill: "#5021D1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }